import slice from './analysesSlice';

export * from './types';
export * from './thunks';

export const {
  populateAnalysisAction,
  populateBuilderInfoAction,
  clearAnalysisAction,
  customizeFormatAction,
  handleResizeAnalysisAction,
  renameAnalysisAction,
  fallbackToDefaultStateAction,
  toggleSingleTypeSwitchAction,
  toggleAllTypeSwitchesAction,
  setAnalysisFavoriteAction,
  addNewAnalysisIncidentAction,
  editAnalysisIncidentAction,
  deleteAnalysisIncidentAction,
  toggleIncidentCreateModalAction,
  updateAliasReplacementAction,
  resetAliasReplacementAction,
  selectPredictionKindAction,
  pathSetDisplaySeqAction,
  pathSetMaxSeqAction,
  pathSetEventsPerStepAction,
  enableEditingForCurrentLoadedAnalysesAction,
  cancelEditingForCurrentLoadedAnalysesAction,
  setFunnelShowInReportStateAction,
  toggleIsConversionViewAction,
  toggleConversionLabelsAction,
  toggleBounceLabelsAction,
  toggleIsRelativeLabelsAction,
  toggleClusterLabelsAction,
  toggleChartSettingsMeasureAction,
  setChartSettingsMeasureVisibility,
  setChartSettingMeasureAction,
  toggleChartSettingsSliceAction,
  toggleTopChartSettingsSlicesAction,
  selectChartTypeAction,
  setSingleDayLabelAction,
  selectChartSettingsSliceAction,
  toggleChartSettingSortAction,
  toggleChartSettingsTopBreakdownsAction,
  setChartSettingChurnAction,
  setChartSettingChartNumberTypeAction,
  setChartSettingsYAxisPositionAction,
  setChartSettingPathNodeCustomizationAction,
  setChartSettingPathObservedNodeIdAction,
  clearAllAnalysesAction,
  clearAllScratchpadAnalysesAction,
  setChartSettingsExpressionSettingsAction,
  setChartSettingsTableSettingsAction,
  setInspectSubjectIdAction,
  customizeMeasureColorAction,
  customizeSliceColorAction,
  setChartSettingGeoMapPositionAction,
  setChartSettingGeoMapHeatmapAction,
  setChartSettingGeoMapDisplayedMeasureKeyAction,
  updateChartSettings,
  updateAnalysisSummaryRichText,
  updateAnalysisSummaryShowInDashboard,
  resetCentralChartSettingsAction,
  setChartSettingYAxisConfigAction,
  toggleIsApplyYAxisFormatAction,
} = slice.actions;

export default slice.reducer;
